'use strict';

var _defineProperty = require("/workspace/node_modules/@babel/runtime/helpers/defineProperty.js");

var _slicedToArray = require("/workspace/node_modules/@babel/runtime/helpers/slicedToArray.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var fetch = require('node-fetch');

var MAX_PAGE_SIZE = 1000; // The Graph max page size

/**
 * Page results from The Graph protocol
 *
 * @param {string} api - The API address
 * @param {Object} query - The Query object
 * @param {string} query.entity - The entity name
 * @param {Object} query.selection - The selection mapping object for GraphQL filters and sorts
 * @param {Object} query.properties - The list of fields to include in the output
 * @param {number} timeout - Number of ms timeout for any single graph paging result (default: 10seconds)
 * @param {number} max - Maximum number of results to return (default: Infinity)
 */

var pageResults = function pageResults(_ref) {
  var api = _ref.api,
      _ref$query = _ref.query,
      entity = _ref$query.entity,
      _ref$query$selection = _ref$query.selection,
      selection = _ref$query$selection === void 0 ? {} : _ref$query$selection,
      _ref$query$properties = _ref$query.properties,
      properties = _ref$query$properties === void 0 ? [] : _ref$query$properties,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 10e3 : _ref$timeout,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? Infinity : _ref$max;
  max = Number(max);
  var pageSize = MAX_PAGE_SIZE; // Note: this approach will call each page in linear order, ensuring it stops as soon as all results
  // are fetched. This could be sped up with a number of requests done in parallel, stopping as soon as any return
  // empty. - JJM

  var runner = function runner(_ref2) {
    var lastId = _ref2.lastId;

    var propToString = function propToString(obj) {
      return Object.entries(obj).filter(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            value = _ref4[1];

        return typeof value !== 'undefined';
      }).map(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
            key = _ref6[0],
            value = _ref6[1];

        return "".concat(key, ":").concat(typeof value === 'object' ? '{' + propToString(value) + '}' : value);
      }).join(',');
    };

    var first = MAX_PAGE_SIZE;

    if (!properties.includes('id')) {
      properties.push('id');
    }

    ; // mix the page size and skip fields into the selection object

    var selectionObj = Object.assign({}, selection, {
      first: first,
      orderBy: 'id',
      where: _objectSpread(_objectSpread({}, selection.where), lastId ? {
        id_gt: "\\\"".concat(lastId, "\\\"")
      } : {})
    });
    var body = "{\"query\":\"{".concat(entity, "(").concat(propToString(selectionObj), "){").concat(properties.join(','), "}}\", \"variables\": null}"); // support query logging in nodejs

    if (typeof process === 'object' && process.env.DEBUG === 'true') {
      console.log(body);
    }

    ;
    return fetch(api, {
      method: 'POST',
      body: body,
      timeout: timeout
    }).then(function (response) {
      return response.json();
    }).then(function (json) {
      if (json.errors) {
        throw Error(JSON.stringify(json.errors));
      }

      var results = json.data[entity]; // stop if we are on the last page

      if (results.length < pageSize || results.length >= max) {
        if (results.length >= max) {
          return results.slice(0, max);
        }

        return results;
      }

      return runner({
        lastId: results[results.length - 1].id
      }).then(function (newResults) {
        return results.concat(newResults);
      });
    });
  };

  return runner({
    lastId: undefined
  });
};

module.exports = pageResults;